import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.less'
import {
    ACCESS_TOKEN,
    KEY_RANDOM,
    KEY_USER_INFO,
    SYS_CONFIG_KEY_AUTOUPDATE,
} from "@/Const";
import { initModel } from '@model/init'

import {
    getCookies,
    isInIFrameApp,
    isStringNullOrEmpty, logger
} from "@/utils";
import {deviceActive, getUserInfo} from "@/api/Api";
import Global from "@/global"
import {getSysConfig} from "@model/sysconfig";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {ConfigProvider, message, Modal} from "antd";
import {ipcInvoke, ipcOn, ipcSend} from "@/common/ipc";
import {APP_WEB, APP_WEB_WWW, DEBUG, isWeb, isWebApp} from "@/electron_interactive";
import CryptoJS from "crypto-js"
import {initLanguage} from "@/language";
import {t} from "i18next";
import ErrorBoundary from "@/ErrorBoundary";
import * as Sentry from "@sentry/react";

initModel()

let szToken = localStorage.getItem(ACCESS_TOKEN);
if (APP_WEB_WWW){
    szToken = getCookies()['token'];
}
if (!isStringNullOrEmpty(szToken)){
    // let lTime = parseInt(localStorage.getItem(EXPIRE_TIME)!);
    // const lNow = new Date().getTime();
    // if (lNow < lTime){
    //
    // }else{
    //     localStorage.removeItem(ACCESS_TOKEN);
    // }

    try{
        const szLocalData = localStorage.getItem(KEY_USER_INFO);
        const bytes = CryptoJS.AES.decrypt(szLocalData,"muenzo"+KEY_RANDOM);
        Global.g_userInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }catch (e){
        console.log('local user info fail')
    }

    getUserInfo({},()=>{

    }).then((res)=>{
        // res.publisherLicense={hasUserLicense:true};
        Global.g_userInfo = res;
    })
}

//是否自动更新
if (!isInIFrameApp()){
    getSysConfig(SYS_CONFIG_KEY_AUTOUPDATE).then(res=>{
        if(res?.value != 'false'){
            //auto update....
            ipcSend('auto-download')
        }
    })
}

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let firebaseConfig = {
    apiKey: "AIzaSyAn_2oSilDp-WFUuWjvJi8wJeN2_Wd2vF8",
    authDomain: "muenzoclient.firebaseapp.com",
    projectId: "muenzoclient",
    storageBucket: "muenzoclient.appspot.com",
    messagingSenderId: "218505753552",
    appId: "1:218505753552:web:753fa00089af28c88c7fd5",
    measurementId: "G-PE0H20CGJ1"
};
if (APP_WEB_WWW){
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    firebaseConfig = {
        apiKey: "AIzaSyAdx0QYaL4Sutg-QLvppRsH8-YZtPvd3go",
        authDomain: "muenzowebcanvas.firebaseapp.com",
        projectId: "muenzowebcanvas",
        storageBucket: "muenzowebcanvas.appspot.com",
        messagingSenderId: "859405038615",
        appId: "1:859405038615:web:72f0e0082de6d545bfd852",
        measurementId: "G-4VB8K4KEQH"
    };
}

// const x = 'muenzo:///?token=token...xxxxx&license_key=license_.xxx';
// const xxxx = getUrlQueryParam(x,'token');
// const yyy = getUrlQueryParam(x,'license_key');
// console.log(xxxx+" ---  "+yyy);


//监听外部打开...
if (!isWeb()){

}

//
setTimeout(()=>{
    // activeDevice('97D2-97QR-84ST-KCL2')
    // postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'draw',id:'aYcz8Btx'})
},3000)


//初始化语言
initLanguage();

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// analytics.app.automaticDataCollectionEnabled = true;

// window.onerror = (errorMessage, scriptURI, lineNo, columnNo, error)=>{
//     errorLog(error?.message+"\n"+error?.stack);
// }

/***这个ANTDESIGN国际化语言为什么要搞这么🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 🤢 简单改配置不行吗，无论如何都不生效...**/
// import moment from 'moment'
// import zhCN from "antd/lib/locale/zh_CN"
// import 'moment/locale/zh-cn'
// moment.locale('zh-cn')
// moment.updateLocale('en', {
//     week:{dow:1}
// });
//
import 'dayjs/locale/en-gb'
import dayjs from "dayjs";
import {isMac} from "@/Utility";
dayjs.locale('en-gb')

let sentryDSN = "https://be11558ba6f627db8c8caab4fbd18301@o4508526762852352.ingest.us.sentry.io/4508527404777472";
if (isMac()){
    sentryDSN = "https://184479b8529af81df73cde492ee35c35@o4508526762852352.ingest.us.sentry.io/4510956873121792";
}

// sentry------------------------------------
const client = Sentry.init({
    dsn: sentryDSN,
    debug:true,
    release:'noteey@1.49.0',
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    integrations: (integrations) => {
        return integrations.filter((integration) => {
            // 禁用可能干扰 PDF.js 的集成
            return ![
                'Breadcrumbs',        // 完全禁用 Breadcrumbs（最彻底）
                // 或者更精细地只禁用 fetch/xhr：
                // 'TryCatch',         // 有时也会干扰
            ].includes(integration.name);
        });
    },
});


ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
    <ConfigProvider
        theme={{
            components: {
                Dropdown: {
                    /* 这里是你的组件 token */
                    colorBgElevated:'var(--dialog-dialog-background-color)',
                    colorText:'var(--text-color)',
                    colorSplit:'var(--line-color)',
                    colorTextDescription:'var(--select-descript-color)',
                    boxShadowSecondary:'var(--box-shadow-popover)',
                    colorTextDisabled:'var(--disable-text-color-1)'
                },
                Select: {
                    colorBgElevated:'var(--background-color-white)',
                    colorText:'var(--text-dark-gray-color)',
                    fontSize:12,
                    fontFamily:'Poppins',
                    colorBgContainer:'transparent',
                    colorBorder:'var(--input-border-color)',
                    colorTextPlaceholder:'var(--input-place-holder-color)',
                    colorPrimaryHover:'var(--input-border-color)',
                    colorPrimary:'var(--input-border-color)',
                    controlOutline:'transparent',
                    boxShadowSecondary:'var(--box-shadow-border)'
                },
                Button: {
                    defaultBorderColor:'transparent',
                    textHoverBg:'var(--hover-background-color)',
                    colorPrimaryHover:'#3670F7EE',
                    defaultHoverBg:'transparent',
                    colorBgSolidActive:'transparent',
                    colorBgSolidHover:'transparent'
                },
                Slider:{
                    dotActiveBorderColor:'#3670F7',
                    trackBg: '#3670F7',
                    trackHoverBg:'#3670F7',
                    handleColor:'#3670F7',
                    railBg:'var(--slider-normal-color)',
                    railHoverBg:'var(--slider-hover-color)',
                    dotSize:6,
                    railSize:2,
                    handleSize:6,
                    handleSizeHover:6,
                    handleLineWidthHover:2
                },
                Modal: {
                    contentBg:'var(--dialog-dialog-background-color)',
                    colorText:'var(--text-color)',
                    boxShadow:'var(--box-shadow-popover)'
                },
                List: {
                    colorText:'var(--text-color)'
                },
                Popover:{
                    colorBgElevated:'var(--dialog-background-color)',
                    colorText:'var(--text-color)',
                    boxShadowSecondary:'var(--box-shadow-popover)'
                },
                Spin:{
                    colorBgMask:'transparent'
                },
                Empty:{
                    colorText:'var(--drag-file-desc-color)',
                    colorTextDescription:'var(--drag-file-desc-color)'
                },
                Input:{
                    // colorIcon:'var(--text-color)',
                    // colorIconHover:'var(--text-color)',
                    colorText:"var(--text-color)"
                },
                Tabs:{
                    itemColor:'var(--tab-item-color)',
                },
                Switch: {
                    colorPrimary: '#2978FF',
                    colorTextQuaternary: 'var(--switch-background-color)',
                    colorTextTertiary: 'var(--switch-background-color)'
                },
                Checkbox:{
                    colorBgContainer:'transparent',
                    colorBorder:'var(--checkbox-border-color)'
                },
                Radio:{
                    colorBgContainer:'transparent',
                    colorBorder:'var(--checkbox-border-color)'
                },
                Form:{
                    labelColor:'var(--text-color)'
                },
                DatePicker:{
                    inputFontSize:12,
                    colorPrimaryBorder:'transparent',
                    colorBgElevated:'var(--dialog-background-color)',
                    colorText:'var(--text-color)',
                    colorTextDisabled:'var(--color-disabled)',
                },
                Calendar:{
                    colorPrimaryBorder:'transparent',
                    colorBgElevated:'var(--dialog-background-color)',
                    colorBgContainer:'var(--dialog-background-color)',
                    fullPanelBg:'var(--dialog-background-color)',
                    lineHeight:1.2,
                },
                Tooltip: {
                    zIndexPopup:999999,//没用的东西。
                },
                Message: {//?????这些属性总是没用。。。。
                    /* 这里是你的组件 token */
                    zIndexPopup:99999,
                    contentBg:'var(--dialog-background-color)',
                },
            },
        }}>

        {
            DEBUG? <App/>: <ErrorBoundary><App /></ErrorBoundary>
        }

    </ConfigProvider>
)
















